import React from 'react';

import { MealItem } from '../MealItem/MealItem';

import * as S from './MealList.styled';

type MealListProps = {
    plan: {
        id: number;
        name: string;
        cover: string;
        cookingLevel: string;
        cookingTime: number;
        kilocalories: number;
        mealType: string;
    }[];
    copy: {
        minutes: string;
        calories: string;
    };
    onMealClick: (mealType: string) => void;
    selectedDate: Date;
};

export const MealList = ({ plan, copy, onMealClick, selectedDate }: MealListProps) => {
    return (
        <S.Container data-testid="meal-list" data-locator="meal-list">
            {plan.map((meal) => (
                <MealItem key={meal.id} {...meal} copy={copy} onClick={onMealClick} selectedDate={selectedDate} />
            ))}
        </S.Container>
    );
};
